import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { PageHeader } from "@/components/KpiCard";
import { api, errMsg } from "@/lib/api";
import { STATION_COLORS } from "@/lib/format";

export default function AdminStations() {
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(null);

  const load = useCallback(() => { api.get("/stations").then((r) => setRows(r.data)); }, []);
  useEffect(load, [load]);

  const save = async () => {
    try {
      if (edit.id) await api.put(`/stations/${edit.id}`, { name: edit.name });
      else await api.post("/stations", { name: edit.name });
      toast.success("Stazione salvata");
      setEdit(null);
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (s) => {
    if (!window.confirm(`Eliminare la stazione "${s.name}"?`)) return;
    try { await api.delete(`/stations/${s.id}`); toast.success("Stazione eliminata"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="fade-up">
      <PageHeader title="Stazioni" subtitle="Anagrafica delle sedi operative.">
        <Button onClick={() => setEdit({ name: "" })} data-testid="add-station-button"><Plus className="mr-2 h-4 w-4" /> Nuova stazione</Button>
      </PageHeader>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {rows.map((s, i) => (
          <div key={s.id} className="group rounded-xl border border-slate-200 bg-white p-5 transition-colors hover:border-slate-300" data-testid={`station-card-${s.id}`}>
            <span className="grid h-10 w-10 place-items-center rounded-lg" style={{ background: `${STATION_COLORS[i % STATION_COLORS.length]}18`, color: STATION_COLORS[i % STATION_COLORS.length] }}><Building2 className="h-5 w-5" /></span>
            <p className="mt-4 font-semibold" data-testid={`station-name-${s.id}`}>{s.name}</p>
            <div className="mt-4 flex gap-1">
              <Button size="sm" variant="outline" onClick={() => setEdit(s)} data-testid={`edit-station-${s.id}`}><Pencil className="h-3.5 w-3.5" /></Button>
              <Button size="sm" variant="outline" onClick={() => remove(s)} data-testid={`delete-station-${s.id}`}><Trash2 className="h-3.5 w-3.5" /></Button>
            </div>
          </div>
        ))}
        {rows.length === 0 && <p className="col-span-full rounded-xl border border-dashed p-8 text-center text-sm text-slate-500">Nessuna stazione. Crea la prima.</p>}
      </div>
      <Dialog open={!!edit} onOpenChange={(o) => !o && setEdit(null)}>
        <DialogContent data-testid="station-dialog">
          <DialogHeader><DialogTitle>{edit?.id ? "Modifica stazione" : "Nuova stazione"}</DialogTitle></DialogHeader>
          <Input placeholder="Nome stazione" value={edit?.name || ""} onChange={(e) => setEdit({ ...edit, name: e.target.value })} data-testid="station-name-input" />
          <DialogFooter><Button onClick={save} disabled={!edit?.name?.trim()} data-testid="station-save-button">Salva</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
